<div class="card grid formgrid fluid">
  <div
    *ngFor="let field of config.fields"
    [ngClass]="getColumnClass()"
    class="p-field"
  >
    <div class="p-flex p-flex-column gap-1">
      <!-- Label -->
      <label *ngIf="config.showLabels !== false && field.showLabel !== false" class="text-600 text-sm font-medium">
        {{ getLabel(field) }}
      </label>

      <!-- Value -->
      <div class="text-base text-color">
        <!-- Icon -->
        <!-- ICON -->
        <ng-container *ngIf="field.type === 'icon'">
          <i class="pi"
             [ngClass]="getIconClass(field)"
             [ngStyle]="{ color: getColor(field), backgroundColor: getBackgroundColor(field) }"
             style="padding: 4px; border-radius: 4px;">
          </i>
        </ng-container>

        <!-- Image -->
        <ng-container *ngIf="field.type === 'image'">
          <img [ngSrc]="data[field.key]" [alt]="getLabel(field)" width="32" height="32" [style.borderRadius]="'4px'">
        </ng-container>

        <!-- Boolean -->
        <ng-container *ngIf="field.type === 'boolean'">
          <p-checkbox [binary]="true" [ngModel]="data[field.key]" disabled></p-checkbox>
        </ng-container>

        <!-- Date -->
        <ng-container *ngIf="field.type === 'date'">
          {{ data[field.key] | date: 'dd.MM.yyyy' }}
        </ng-container>

        <!-- Text -->
        <ng-container *ngIf="!field.type || field.type === 'text'">
          {{ data[field.key] }}
        </ng-container>
      </div>
    </div>
  </div>
</div>
